import React from "react";

// Style
import "assets/css/rc-tree.min.css";

// components
import Img from "components/Img";
import NoData from "components/NoData";

export const EmptyTree: React.FC = () => <div className="thesaurus__no-data mt30">
  <div className="thesaurus__wrapper-box relative text-align-cn">
    <Img name="box" alt="Empty box" className="relative" />
    <div className="projects__no-data-img-bg" />
  </div>
  <NoData className="text-align-cn" />
</div>;

export default EmptyTree;
